<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Float } from '#library/components.schema.build.ts'
	import Image from '#components/image.svelte'

	interface Props {
		blok: Blok<Float>
	}

	let { blok }: Props = $props()
</script>

<section class="float {blok.theme}" {...attrs(blok)}>
	{#if blok.images?.length}
		<div class="contain">
			{#each blok.images as image, i (i)}
				{#if image.filename}
					<figure class="figure">
						<Image src={image.filename} alt={image.alt} focus={image.focus} fill />
					</figure>
				{/if}
			{/each}
		</div>
	{/if}
</section>

<style lang="css">
	.float {
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.contain {
		aspect-ratio: 9 / 16;

		@media (--from-mobile) {
			aspect-ratio: 16 / 9;
		}
	}

	.figure {
		position: absolute;

		&:nth-child(1) {
			inset: 0% auto auto 50%;
			size: 40% 50%;

			@media (--from-mobile) {
				inset: 41% auto auto 0%;
				size: 56% 24%;
			}
		}

		&:nth-child(2) {
			inset: 36% auto auto 0%;
			size: 20% 42%;

			@media (--from-mobile) {
				inset: 0% auto auto 19%;
				size: 30% 21%;
			}
		}

		&:nth-child(3) {
			inset: 50% auto auto 35%;
			size: 20% 50%;

			@media (--from-mobile) {
				inset: 24% auto auto 30%;
				size: 41% 27%;
			}
		}

		&:nth-child(4) {
			inset: auto auto 0 0;
			size: 25% 54%;

			@media (--from-mobile) {
				inset: 12% auto auto 64%;
				size: 64% 36%;
			}
		}
	}
</style>
